import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent, ModalData, ModalTitleIcons } from '@modeso/aumico-lib-core-fe';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
    constructor(private readonly dialog: MatDialog) {}
    private _isPopUpShown: boolean;

    get isPopUpShown(): boolean {
        return this._isPopUpShown;
    }

    openErrorDialog(messageKey: string, titleKey?: string): void {
        this._isPopUpShown = true;
        this.dialog
            .open<ModalComponent, ModalData>(ModalComponent, {
                disableClose: false,
                panelClass: 'custom-modalbox',
                data: {
                    showCloseButton: true,
                    titleIcon: ModalTitleIcons.DEFAULT,
                    titleLocalizationKey: titleKey,
                    content: {
                        text: [messageKey],
                    },
                },
            })
            .afterClosed()
            .subscribe(() => (this._isPopUpShown = false));
    }
}
